import { Component } from '@angular/core'
import { ControlWidget } from 'ngx-schema-form'

@Component({
  selector: 'my-custom-number-input',
  template: `
      <div class="ui-g-12 sf-field-container">
        <div class="ui-g-12 ui-md-4">
          <span class="label" [attr.for]="id" [ngClass]="{'required': -1!==(formProperty.parent.schema.required||[]).indexOf(formProperty.path.split('/').slice(-1)[0])}">
            {{ schema.description }}
          </span>
        </div>
        <div class="ui-g-12 ui-md-8">
          <input
            type="number"
            pInputText
            [name]="name"
            [min]="schema.min||0"
            [max]="schema.max||null"
            [attr.readonly]="schema.readOnly?true:null"
            [attr.id]="id"
            [formControl]="control"
            [attr.placeholder]="schema.placeholder"
            [attr.size]="schema.widget?.size||null"
            [disabled]="schema.readOnly||false"
          >
        </div>
      </div>
  `,
  styleUrls: ['./custom-widgets-styles.css']
})
export class NumberWidget extends ControlWidget {}



// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/custom-widgets/number.widget.ts